import { Timestamp } from 'firebase/firestore'

/**
 * Convert a Firestore value to a JS `Date` at the service-layer boundary.
 *
 * Firestore `Timestamp` objects do not serialize cleanly to JSON and behave
 * differently in tests vs production. Every service maps documents through this
 * before returning, so hooks/components/state only ever see `Date`. A `Date`
 * passed in (already converted, or a test fixture) is returned untouched.
 */
export const toDate = (value: Timestamp | Date): Date =>
  value instanceof Timestamp ? value.toDate() : value
